// extracted by mini-css-extract-plugin
module.exports = {"storeList":"RetailerList_storeList__3AHkD","cardContainer":"RetailerList_cardContainer__2Zv-2","card":"RetailerList_card__1FuFB"};